module.exports = __webpack_public_path__ + "img/Zambia.4d168b6f.png";